<template>
    <b-form>
        <TarefaRequisicaoForm v-if="mostrarTarefaForm" :id="idTarefa" :isVisualizacao="isVisualizacao"
            @close="fecharModalTarefa" :prefix="title"></TarefaRequisicaoForm>

        <b-tabs v-model="activeTab">
            <b-tab title="Requisição">
                <b-card class='mt-3' bg-variant="light">
                    <b-row>
                        <b-col cols="4">
                            <LgFormInput v-model="form.numeroRequisicaoCompra" :disabled="true"
                                label="Número da Requisição:*" />
                        </b-col>
                        <b-col cols="4">
                            <LgFormInput v-model="form.numeroOficio" :disabled="isViewMode"
                                label="Número do Ofício:*" />
                        </b-col>
                        <b-col cols="4">
                            <LgFormDate description=" " label="Data do Ofício:*" v-model="form.dataOficio"
                                :disabled="isViewMode" />
                        </b-col>

                    </b-row>
                    <b-row>

                        <b-col cols="4">

                            <lg-finder-page-unidade-administrativa :prefix="title"
                                id="finderUnidadeAdministrativaConsultarRequisicoesForm"
                                @onselect="handleSelectUnidadeAdministrativa" v-model="form.departamento"
                                invalidFeedback="Informe uma unidade administrativa!" />


                        </b-col>

                        <b-col cols="5">

                            <lg-form-select :disabled="isViewMode  || (ata != null)"
                                v-model="form.tipoRequisicaoCompra" :loadFunction="listTipos"
                                labelFormGroupBind="Tipo Requisição Compra:*" label="descricao" description="" />


                        </b-col>
                        <b-col v-if="form.tipoRequisicaoCompra && form.tipoRequisicaoCompra.id == 3" cols="3">

                            <LgFinderPageAta :disabled="isViewMode || (ata != null)"
                                v-if="form.tipoRequisicaoCompra && form.tipoRequisicaoCompra.id == 3"
                                id="finderAtaRequisicaoCompra" @onselect="handleAta" v-model="form.ata" label="Ata:"
                                :prefix="title">
                            </LgFinderPageAta>


                        </b-col>

                        <b-col cols="3">
                            <lg-form-const-select
                                :disabled="desativarTipoCompra || isViewMode || (idRequisicao != null) || (ata != null)"
                                label="Tipo Compra:*" v-model="form.codGrupoProduto" :options="tiposCompraList" />

                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <LgFormTextarea description=" " v-model="form.descricao" :disabled="isViewMode"
                                label="Descrição:*" />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12">
                            <LgFormTextarea description=" " v-model="form.justificativa" :disabled="isViewMode"
                                label="Justificativa:*" />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12">
                            <LgFormTextarea description=" " v-model="form.observacao" :disabled="isViewMode"
                                label="Observação:" />
                        </b-col>
                    </b-row>
                </b-card>
            </b-tab>
            <b-tab title="Itens">
                <b-row no-gutters class="my-2 d-flex justify-content-end">
                    <b-col md="12" class="d-flex justify-content-end">
                        <b-button v-if="ata == null" @click="abrirModalAdicionarItem" variant="primary" class="mb-2"
                            :disabled="isViewMode">
                            +
                        </b-button>
                    </b-col>
                </b-row>
                <b-table :items="form.item" :fields="itemFields" responsive="sm" :key="tableKey">

                    <template #cell(produto)="data">
                        <LgFormInput class='mt-3' classFormGroup='pl-0' :value="data.item.descricaoResumida"
                            placeholder="Produto" />
                    </template>
                    <template #cell(quantidade)="data">
                        <LgFormInput @input="handleQuantidade(data.item)" class='mt-3' classFormGroup='pl-0'
                            v-model="data.item.quantidade" type="number" placeholder="Quantidade"
                            :disabled="isViewMode" />
                    </template>
                    <template #cell(acoes)="data">
                        <b-button @click="removerItem(data)" variant="danger" size="sm" :disabled="isViewMode">
                            <b-icon icon="trash" />
                        </b-button>
                    </template>
                </b-table>
                <ModalConsultaProdutoCadastroEssencial v-if='showModalConsultaProdutoCadastroEssencial'
                    id="finderProdutoRegistroForm" :grupoProduto="form.codGrupoProduto" @onselect="handleSelectProduto"
                    invalidFeedback="Informe um produto!" :prefix="title" />
            </b-tab>
            <b-tab title="Anexos">
                <b-row no-gutters class="my-2 d-flex justify-content-end">
                    <b-col md="12" class="d-flex justify-content-end">
                        <b-button @click="abrirModalAdicionarAnexo" variant="primary" class="mb-2"
                            :disabled="isViewMode">
                            +
                        </b-button>
                    </b-col>
                </b-row>
                <b-table :items="form.anexos" :fields="anexoFields" responsive="sm" :key='tableKeyAnexos'>
                    <template #cell(tipoArquivo)="data">
                        <LgFormConstSelect class='mt-3' v-model="data.item.tipoArquivo" :options="tipoAnexoOptions"
                            :disabled="isViewMode" />
                    </template>
                    <template #cell(descricao)="data">
                        <LgFormInput class='mt-3' v-model="data.item.descricao" placeholder="Descrição"
                            :disabled="isViewMode" />
                    </template>
                    <template #cell(datacriacao)="data">
                        <span>{{ formatDate(data.item.datacriacao) }}</span>
                    </template>
                    <template #cell(nomeArquivo)="data">
                        <b-link @click="baixarArquivo(data.item)" class="text-primary">
                            {{ data.item.nomeArquivo }}
                        </b-link>
                    </template>
                    <template #cell(acoes)="data">
                        <b-button @click="form.anexos.splice(data.index, 1); tableKeyAnexos += 1" variant="danger"
                            size="sm" :disabled="isViewMode">
                            <b-icon icon="trash" />
                        </b-button>
                    </template>
                </b-table>
                <input type="file" ref="fileInput" @change="handleFileChange" style="display: none;" />
            </b-tab>
            <b-tab title="Tarefas" v-if="idRequisicao">
                <b-table id="detalhe-tarefas" responsive class="mt-2" small :items="tarefas" :fields="tarefasFields"
                    :busy="busyTarefas" show-empty>
                    <template #empty>
                        <p>Nenhuma tarefa encontrada</p>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template v-slot:cell(detalheTarefa)="row">
                        <b-button :id="row.index + 'visualizar-tarefa'" class="my-2" size="sm" pill variant="primary"
                            @click="abrirModalTarefaDetalhar(row.item)">
                            <b-icon icon="file-earmark-text" />
                            <b-tooltip :target="row.index + 'visualizar-tarefa'"
                                title="Visualizar a tarefa atual..."></b-tooltip>
                        </b-button>
                    </template>
                </b-table>
            </b-tab>
        </b-tabs>
        <div class="d-flex justify-content-center mt-3">
            <b-button id="confirmarSalvar" @click="submitForm" variant="success" style="height: 30px" pill size="sm"
                :disabled="isViewMode">
                <div class="btn-size-alinhamento">
                    <b-icon icon="check-circle" />
                </div>
            </b-button>
            <b-button id="cancelarSalvar" class="ml-2" @click="cancelarSalvar" style="height: 30px" pill size="sm"
                variant="danger">
                <div class="btn-size-alinhamento">
                    <b-icon icon="x-circle" />
                </div>
            </b-button>
        </div>
    </b-form>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import RequisicaoCompraService from "@/core/api/RequisicaoCompraService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFormTextarea from "@/core/components/Form/LgFormTextarea.vue"
import ModalConsultaProdutoCadastroEssencial from "@/core/components/Modals/ModalConsultaProdutoCadastroEssencial.vue"
import { downloadArquivo } from "@/core/utils/DownloadArquivoUtil.js"
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue"
import LgFinderPageAta from "@/components/Finders/LgFinderPageAta.vue";
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue"
import moment from "moment"
import StatusEnum from "@/core/utils/StatusEnum"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import TarefaRequisicaoForm from "./TarefaRequisicaoForm.vue"

export default {
    components: {
        LgFormDate, LgFormConstSelect, LgFormInput, LgFormTextarea,
        ModalConsultaProdutoCadastroEssencial, LgFormSelect, LgFinderPageAta,
        LgFinderPageUnidadeAdministrativa, TarefaRequisicaoForm
    },
    props: {
        ata: {
            type: Number,
            default: null,
        },
        idRequisicao: {
            type: Number,
            default: null,
        },
        isViewMode: {
            type: Boolean,
            default: false
        },
        prefix: {
            type: Array,
            required: true
        }
    },
    computed: {
        updatedPrefix() {
            return [...this.prefix, "Cadastro"]
        },
        title() {
            return this.updatedPrefix.join(" > ")
        },
    },
    data() {
        return {
            activeTab: 0,
            showModalConsultaProdutoCadastroEssencial: false,
            tiposCompraList: [
                { key: "filtertipoProduto", text: "Todos", value: null },
                { key: "filtertipoProduto", text: "Material de Consumo", value: 4 },
                { key: "filtertipoProduto", text: "Material Permanente", value: 5 },
                { key: "filtertipoProduto", text: "Serviço", value: 6 },
            ],

            desativarTipoCompra: false,
            form: {

                departamento: {},
                codGrupoProduto: null,
                ata: {},
                tipoRequisicaoCompra: {},
                numeroRequisicaoCompra: "",
                numeroOficio: "",
                dataOficio: null,
                descricao: "",
                justificativa: "",
                observacao: "",
                item: [],
                anexos: [],
            },

            itemFields: this.ata ? [{ key: 'numero', label: 'Número' },
            { key: 'descricaoResumida', label: 'Produto' },
            { key: 'quantidade', label: 'Quantidade' },
            { key: 'quantidadeMaximaAta', label: "Quantidades Restantes na Ata" },
            { key: 'acoes', label: '' }] : [
                { key: 'numero', label: 'Número' },
                { key: 'descricaoResumida', label: 'Produto' },
                { key: 'quantidade', label: 'Quantidade' },
                { key: 'acoes', label: '' },
            ],
            anexoFields: [
                { key: 'nomeArquivo', label: 'Arquivo' },
                { key: 'tipoArquivo', label: 'Tipo' },
                { key: 'descricao', label: 'Descrição' },
                { key: 'datacriacao', label: 'Data de Criação' },
                { key: 'acoes', label: '' },
            ],
            tarefasFields: [
                { key: "id", label: "Nº" },
                { key: "status", label: "Status" },
                { key: "departamento", label: "Unidade Administrativa" },
                { key: "pessoa", label: "Responsável" },
                { key: "tipoTarefaRequisicao", label: "Tarefa" },
                {
                    key: "data",
                    label: "Data",
                    formatter: value => moment(String(value)).format("DD/MM/YYYY HH:mm"),
                },
                { key: "action", label: "" },
                { key: "detalheTarefa", label: " " },
            ],
            tarefas: [],
            busyTarefas: false,
            idTarefa: null,
            isVisualizacao: false,
            mostrarTarefaForm: false,
            tipoAnexoOptions: [
                { value: null, text: "Selecione o tipo de anexo" },
                { value: 5, text: "Ofício" },
                { value: 70, text: "Planilha" },
                { value: 78, text: "Justificativa" },
                { value: 79, text: "Outros" },
            ],
            tableKey: 0,
            tableKeyAnexos: 0,
            StatusEnum: StatusEnum,
        }
    },
    async beforeMount() {
        this.$serviceTarefa = new ResourceService(`/api/tarefasrequisicao`);
        this.brand = JSON.parse(localStorage.getItem("context"));

        if (this.idRequisicao) {
            await this.fetchRequisicaoCompra();
            await this.loadTarefas();
        }
        else
            if (this.ata) {
                this.form.item = (await new ResourceService("/api/produto/find-produtos-ata").get(this.ata)).data
                this.form.item.forEach(itemLista => {
                    itemLista.produtoDto = JSON.parse(JSON.stringify(itemLista));
                })
                this.form.ata = (await new ResourceService("/api/atas/simplificado").get(this.ata)).data;
                this.form.tipoRequisicaoCompra = (await new ResourceService("/api/tipo-requisicao-compra").get(3)).data;
            }
    },
    methods: {
        async loadTarefas() {
            if (!this.idRequisicao) return;

            this.busyTarefas = true;
            const { data } = await this.$serviceTarefa.get("buscar-tarefa-requisicao/" + this.idRequisicao);
            this.tarefas = data;
            this.busyTarefas = false;
        },

        isBtnIniciarVisible(data) {
            return data != null &&
                data.status &&
                data.status.id === StatusEnum.TAREFA_REQUISICAO_AGUARDANDO.value &&
                data.departamento &&
                data.departamento.id === this.brand.departamento.id &&
                verificaPrivilegio(PrivilegiosEnum.REQUISICAO_COMPRA_APROVACAO);
        },

        isBtnContinuarVisible(data) {
            return data != null &&
                data.status &&
                data.status.id === StatusEnum.TAREFA_REQUISICAO_EM_ANDAMENTO.value &&
                data.departamento &&
                data.departamento.id === this.brand.departamento.id &&
                verificaPrivilegio(PrivilegiosEnum.REQUISICAO_COMPRA_APROVACAO);
        },

        async iniciarTarefa(item) {
            let response = await this.$confirm(
                `Deseja iniciar esta tarefa (${item.tipoTarefaRequisicao.descricao}) ?`
            );
            if (response) {
                try {
                    this.busyTarefas = true;
                    await this.$serviceTarefa.put("iniciar-tarefa/" + item.id);
                    this.busyTarefas = false;
                    this.$notify({
                        type: "success",
                        message: "Tarefa iniciada com sucesso!",
                    });
                    this.abrirModalTarefa(item);
                } catch (error) {
                    this.busyTarefas = false;
                    this.$notify({
                        type: "danger",
                        message: error.response.message,
                    });
                }
            }
        },

        abrirModalTarefa(item) {
            this.idTarefa = item.id;
            this.mostrarTarefaForm = true;
        },

        abrirModalTarefaDetalhar(item) {
            this.isVisualizacao = true;
            this.abrirModalTarefa(item);
        },

        fecharModalTarefa() {
            this.idTarefa = null;
            this.isVisualizacao = false;
            this.mostrarTarefaForm = false;
            this.loadTarefas();
        },

        handleQuantidade(item) {
            if (item.quantidade > item.quantidadeMaximaAta) {
                this.$notify({
                    type: 'danger',
                    message: 'A quantidade do Produto não pode ser maior do que a quantidade restante da Ata'
                })

                this.form.item.forEach(itemLista => {
                    if (itemLista.id == item.id)
                        item.quantidade = 0;
                })
            }
        },
        handleSelectUnidadeAdministrativa(departamento) {
            this.form.departamento = departamento;
        },
        removerItem(data) {
            this.form.item.splice(data.index, 1)

            if (this.form.item.length == 0)
                this.desativarTipoCompra = false;
        },
        handleAta(ata) {
            this.form.ata = ata;
        },
        async listTipos({ filter, page = 1 }) {
            return new ResourceService(`/api/tipo-requisicao-compra`).findAll({ filter, page, limit: 5 })
        },

        handleSelectProduto(produtoDto) {
            if (this.form.item.some(item => item.produtoDto.id === produtoDto.id)) {
                this.$bvToast.toast('Produto já adicionado.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                this.showModalConsultaProdutoCadastroEssencial = false
                return
            }
            this.showModalConsultaProdutoCadastroEssencial = false
            var produtoObj = {
                numero: produtoDto.numero,
                descricaoResumida: produtoDto.descricaoResumida,
                quantidade: 1,
                produtoDto: produtoDto
            }
            if (produtoDto) {
                this.desativarTipoCompra = true;

                this.form.item.push(produtoObj)
                this.tableKey += 1
                this.showModalConsultaProdutoCadastroEssencial = false
            }
        },
        async submitForm() {


            if (!this.form.numeroOficio) {
                this.$notify({
                    type: 'danger',
                    message: 'Por favor, preencha o campo Nº do Ofício.'
                })
                return
            }
            if (!this.form.dataOficio) {
                this.$notify({
                    type: 'danger',
                    message: 'Por favor, preencha o campo Data do Ofício.'
                })
                return
            }

            if (!this.form.departamento || !this.form.departamento.id) {
                this.$notify({
                    type: 'danger',
                    message: 'Por favor, selecione o Departamento'
                })
                return
            }


            if (!this.form.tipoRequisicaoCompra || !this.form.tipoRequisicaoCompra.id) {
                this.$notify({
                    type: 'danger',
                    message: 'Por favor, selecione o Tipo de Requisição de Compra'
                })
                return
            }

            if (!this.form.descricao) {
                this.$notify({
                    type: 'danger',
                    message: 'Por favor, preencha o campo Descrição.'
                })
                return
            }
            if (!this.form.justificativa) {
                this.$notify({
                    type: 'danger',
                    message: 'Por favor, preencha o campo Justificativa.'
                })
                return
            }
            if (this.form.item.length === 0) {
                this.$notify({
                    type: 'danger',
                    message: 'Por favor, adicione pelo menos um item.'
                })
                return
            }
            if (this.form.item.some(item => item.quantidade <= 0)) {
                this.$notify({
                    type: 'danger',
                    message: 'Por favor, preencha a quantidade de todos os itens corretamente.'
                })
                return
            }
            if (this.form.anexos.some(anexo => !anexo.tipoArquivo)) {
                this.$notify({
                    type: 'danger',
                    message: 'Por favor, selecione o tipo de todos os anexos.'
                })
                return
            }
            if (this.form.anexos.some(anexo => !anexo.descricao)) {
                this.$notify({
                    type: 'danger',
                    message: 'Por favor, preencha a descrição de todos os anexos.'
                })
                return
            }



            try {
                if (this.idRequisicao) {
                    await RequisicaoCompraService.update(this.idRequisicao, this.form)
                    this.$notify({
                        type: 'success',
                        message: 'Requisição atualizada com sucesso!'
                    })
                } else {
                    await RequisicaoCompraService.create(this.form)
                    this.$notify({
                        type: 'success',
                        message: 'Requisição criada com sucesso!'
                    })
                }
                this.$emit('close')
            } catch (error) {
                this.$notify({
                    type: 'danger',
                    message: error.response.message
                })
            }
        },
        cancelarSalvar() {
            this.$emit('close')
        },
        abrirModalAdicionarItem() {
            this.showModalConsultaProdutoCadastroEssencial = true
        },
        abrirModalAdicionarAnexo() {
            this.$refs.fileInput.click()
        },
        async handleFileChange(event) {
            const file = event.target.files[0]
            if (file) {
                const arquivoBytes = await this.convertFileToBase64(file)
                const novoAnexo = {
                    tipoArquivo: null,
                    descricao: "",
                    datacriacao: new Date().toISOString(),
                    arquivo: file,
                    nomeArquivo: file.name,
                    arquivoBytes: arquivoBytes,
                }
                this.form.anexos = [...this.form.anexos, novoAnexo]
                this.tableKeyAnexos += 1
                this.$refs.fileInput.value = null
            }
        },
        async convertFileToBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onload = () => resolve(reader.result.split(',')[1])
                reader.onerror = reject
                reader.readAsDataURL(file)
            })
        },
        baixarArquivo(arquivo) {
            downloadArquivo(arquivo)
        },
        formatDate(dateString) {
            if (!dateString) return "N/A"
            const date = new Date(dateString)
            const day = String(date.getDate()).padStart(2, '0')
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const year = date.getFullYear()
            return `${day}/${month}/${year}`
        },
        async fetchRequisicaoCompra() {
            try {
                const response = await RequisicaoCompraService.findById(this.idRequisicao)
                response.data.codGrupoProduto = response.data.grupoProduto && response.data.grupoProduto.id ? response.data.grupoProduto.id : null;
                this.form = response.data
                this.form.item = this.form.item || []
                this.form.anexos = this.form.anexos || []
            } catch (error) {
                this.$notify({
                    type: 'danger',
                    message: error.response.message
                })
            }
        },
    },
}
</script>

<style scoped>
.badge {
    font-size: 85% !important;
    padding: 5px 10px !important;
}

.btn-size-alinhamento {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
